import { LocalDate, LocalTime } from '@js-joda/core';

import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { Message, MessageType } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { parseToDateWithMidnightAdjustment } from '../AppointmentForm.utils';

import { useAppointmentWithinSchedule } from './AppointmentAvailabilityStatus.hooks';

type AppointmentAvailabilityStatusProps = {
   readonly date: LocalDate;
   readonly startTime: LocalTime;
   readonly endTime: LocalTime;
   readonly practitionerId: PractitionerId;
};

export const AppointmentAvailabilityStatus = (props: AppointmentAvailabilityStatusProps): JSX.Element | null => {
   const appointmentWithinSchedule = useAppointmentWithinSchedule({
      startTime: parseToDateWithMidnightAdjustment('START', props.date, props.startTime),
      endTime: parseToDateWithMidnightAdjustment('END', props.date, props.endTime),
      practitionerId: props.practitionerId,
   });

   if (appointmentWithinSchedule === false) {
      return (
         <Message
            type={MessageType.INFORMATIVE}
            displayIndicator
            label={appointmentsTranslationKeys.selectedSlotIsNotInSchedule}
            testId={'appointmentAvailabilityStatus'}
         />
      );
   }

   return null;
};
